import API from './axios';

const clean = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined)
);

export const fetchGananciasManuales = ({ page = 1, pageSize = 20 } = {}) =>
  API.get('/finanzas/ganancias-manuales', { params: { page, pageSize } }).then((res) => res.data);

export const createGananciaManual = (data) =>
  API.post('/finanzas/ganancias-manuales', data).then((res) => res.data);

export const updateGananciaManual = (id, data) =>
  API.put(`/finanzas/ganancias-manuales/${id}`, data).then((res) => res.data);

export const deleteGananciaManual = (id) => API.delete(`/finanzas/ganancias-manuales/${id}`);

export const fetchPublicidad = ({ page = 1, pageSize = 20 } = {}) =>
  API.get('/finanzas/publicidad', { params: { page, pageSize } }).then((res) => res.data);

export const createPublicidad = (data) =>
  API.post('/finanzas/publicidad', data).then((res) => res.data);

export const updatePublicidad = (id, data) =>
  API.put(`/finanzas/publicidad/${id}`, data).then((res) => res.data);

export const deletePublicidad = (id) => API.delete(`/finanzas/publicidad/${id}`);

export const fetchRetiros = ({ page = 1, pageSize = 20 } = {}) =>
  API.get('/finanzas/retiros', { params: { page, pageSize } }).then((res) => res.data);

export const createRetiro = (data) =>
  API.post('/finanzas/retiros', data).then((res) => res.data);

export const updateRetiro = (id, data) =>
  API.put(`/finanzas/retiros/${id}`, data).then((res) => res.data);

export const deleteRetiro = (id) => API.delete(`/finanzas/retiros/${id}`);

export const fetchRentabilidad = ({ from, to, categoriaId, tz = '-06:00' } = {}) =>
  API.get('/finanzas/rentabilidad', { params: clean({ from, to, categoriaId, tz }) })
    .then((res) => res.data);
